import * as React from 'react';
import messages from '@helpcenter/error-boundary/src/messages';
import {
    Root,
    Container,
    MessageContainer,
    ErrorMessage,
    HelpText,
    PageErrorIcon,
} from '@helpcenter/error-boundary/src/styled';
import { FormattedMessage } from 'react-intl-next';
import { Footer } from 'view/layout/footer';
import Heading from '@atlaskit/heading';
import { Text, Stack } from '@atlaskit/primitives';
import { UseTypographyMigratedComponent } from '@atlassian/help-center-common-util/enable-typography-migration';

interface GenericErrorProps {
    title?: React.ReactElement;
    message?: React.ReactElement;
    hideFooter?: boolean;
}

const GenericErrorPage: React.FunctionComponent<GenericErrorProps> = ({ title, message, hideFooter }) => {
    return (
        <Root>
            <Container>
                <PageErrorIcon />
                <MessageContainer>
                    <UseTypographyMigratedComponent
                        migratedComponent={
                            <Stack space="space.200" alignInline="center">
                                <Heading size="xlarge">
                                    {title ? title : <FormattedMessage {...messages.errorTitle} />}
                                </Heading>
                                <Text align="center">
                                    {message ? message : <FormattedMessage {...messages.errorMessage} />}
                                </Text>
                            </Stack>
                        }
                    >
                        <ErrorMessage>{title ? title : <FormattedMessage {...messages.errorTitle} />}</ErrorMessage>
                        <HelpText>{message ? message : <FormattedMessage {...messages.errorMessage} />}</HelpText>
                    </UseTypographyMigratedComponent>
                </MessageContainer>
            </Container>
            {!hideFooter && <Footer />}
        </Root>
    );
};

export default GenericErrorPage;
